import React from 'react'
import Svg from 'assets/phone.svg'
import ContactButton from './ContactButton'

export default () => (
  <ContactButton href="tel:+48534898311" svgId={Svg.id!} text="+48 534 898 311" />
)
